import styles from './Spinner.module.scss';
import Spinner from './Spinner';

type Props = {
  label?: string | null;
  spinnerClassName?: string
};

const PageLoadingIndicator = ({ label, spinnerClassName = '' }: Props) => (
  <div className={styles.loadingPage}>
    <Spinner label={label} className={spinnerClassName} />
  </div>
);

export default PageLoadingIndicator;
